import { TextField } from '@mui/material'
import {useState} from 'react'

let timeoutValue = 0
const timeoutTime = 200

const PoolTextField = ({value, onChange, timeout=timeoutTime, ...props}) => {

    const [data, setData] = useState(value)

    return (
        <TextField 
            value={data || value}
            onChange={(e)=>{
                clearTimeout(timeoutValue)
                setData(e)
                setData(e.target.value)
                timeoutValue = setTimeout(()=> onChange(e), timeout)
            }}
            {...props}
        />
    )
}

export default PoolTextField